import React, {useState} from 'react'
import {Container,CategoryWrapper,Title,CategoryInfoWrapper,NumberWrapper,NameWrapper,Wrapper,CheckBoxInput,BrandWrapper,CheckBoxLabel,LabelWrapper,RatingTitle,RatingWrapper,PriceWrapper,InputWarpper,PriceLabel,PriceInput,RangeInput,MinInputWrapper,ButtonWrapper,Buttons,StarWrapper,ResetInput} from "./style"
import Rating from "../Rating"
import {data,filter} from "../../mock/categoryData"

const CategorySidebar = () => {
   const [filters, setFilter] = useState([])
   const [minPrice, setMinPrice] = useState("")
   const [maxPrice, setMaxPrice] = useState("")
   const [rangeValue, setRangeValue] = useState("")


   const addFilterItems = (e) =>{
     e.preventDefault()
      const info = {
        filters,minPrice,maxPrice,rangeValue
      }
      console.log(info);
   }
 
   const handleReset = () =>{
    setMaxPrice("")
    setMinPrice("")
    setFilter([])
    setRangeValue("")
   }

   return (
    <Container>
        {/* about Category Information */}
      <CategoryWrapper>
        <Title>Categories</Title>
      </CategoryWrapper>
      <CategoryInfoWrapper>
        {data.map((value) => {
          return(
              <Wrapper key={value.id}>
                <NameWrapper>{value.name}</NameWrapper>
                <NumberWrapper>{value.number}</NumberWrapper>
              </Wrapper>
              )
          })}
        </CategoryInfoWrapper>
<form action="">
        {/* Brands Inforamtion */}
      <BrandWrapper>
        <Title>Brands</Title>
          {filter.map((value) =>{
            return(
          <LabelWrapper key={value.id}>
              <CheckBoxInput  value={value.name}   onChange={(e) => setFilter((prev)=>[...prev, e.target.value])} type="checkbox"/> 
              <CheckBoxLabel>
              {value.name}
              </CheckBoxLabel>
          </LabelWrapper>
            )
      })}
    </BrandWrapper>
     {/* Rating */}
     <RatingWrapper>
       <RatingTitle>Rating</RatingTitle>
       <StarWrapper>
          <LabelWrapper top>
            <CheckBoxInput type="checkbox"/> <Rating/>
          </LabelWrapper >
            <LabelWrapper top>
            <CheckBoxInput type="checkbox"/><Rating/>
          </LabelWrapper >
          <LabelWrapper top>
            <CheckBoxInput type="checkbox"/> <Rating/>
          </LabelWrapper>
            <LabelWrapper top>
            <CheckBoxInput type="checkbox"/><Rating/>
          </LabelWrapper>
        </StarWrapper>
      </RatingWrapper>

     {/* Price */}
     <PriceWrapper>
       <Title>Price</Title>
       <RangeInput value={rangeValue} onChange={(e) => setRangeValue(e.target.value)} type="range" min="0"  max="50"/>
       <InputWarpper>
       <MinInputWrapper>
         <PriceLabel >Min</PriceLabel>
         <PriceInput value={minPrice}  onChange={(e) => setMinPrice(e.target.value)}  placeholder="0"/>
       </MinInputWrapper>
       <MinInputWrapper maximum>
         <PriceLabel >Max</PriceLabel>
         <PriceInput  value={maxPrice}  onChange={(e) => setMaxPrice(e.target.value)}  placeholder="000"/>
       </MinInputWrapper> 
       </InputWarpper>
       <ButtonWrapper>
         <Buttons  onClick={addFilterItems}>Apply</Buttons>
         <ResetInput onClick={handleReset} type="reset" />
         </ButtonWrapper>
        </PriceWrapper>
</form>
    </Container>
   )
}

export default CategorySidebar